import React from 'react'
import './newsletterSignupMC.scss'

function renderMailChimpSignUpForm (placeholder, buttonText, align) {
  return {__html: `
    <link href="//cdn-images.mailchimp.com/embedcode/horizontal-slim-10_7.css" rel="stylesheet" type="text/css">
    <style type="text/css">
      #mc_embed_signup{background:#fff; clear:left; font:14px Helvetica,Arial,sans-serif; width:80%; ${align === 'center' ? 'margin:0 auto;' : ''}}
      #mc_input_container {padding: 10px 0; width: 70%; height: 50px; float:left; }
      #mc_button_container{padding: 10px 0; width: 30%; height: 50px; margin-left: 70%;}
    </style>
    <div id="mc_embed_signup">
    <form action="https://gardenlifepro.us7.list-manage.com/subscribe/post?u=43780426e2b59a9344bb2966c&amp;id=85cb8bebd1" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
      <div id="mc_embed_signup_scroll">
          <div id="mc_input_container">
            <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="${placeholder}" required>
          </div>
          <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
          <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_43780426e2b59a9344bb2966c_85cb8bebd1" tabindex="-1" value=""></div>
          <div id="mc_button_container"><input type="submit" value="${buttonText}" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
      </div>
    </form>
    </div>
    <!--End mc_embed_signup-->`
  }
}

function renderContainer (placeholder, buttonText, align) {
  return (
    <div dangerouslySetInnerHTML={renderMailChimpSignUpForm(placeholder, buttonText, align)}></div>
  )
}

const NewsletterSignupMC = (props) => {
  const {
    placeholder = 'your@email.com',
    buttonText = 'Sign up',
    align = 'center'
  } = props

  return (
    renderContainer(placeholder, buttonText, align)
  )
}

export default NewsletterSignupMC
